import React from "react";
import _ from "lodash";
import moment from "moment";
import { Card, Col } from "react-bootstrap";
import { salesTargetAndForecastMapping } from "../constants";
import { DeleteIconButton, EditIconButton } from "../../../components/button/icon-action-buttons";

export default function SFDetailsCard(props) {
  const getAssignee = (data) => {
    if (data.typeOfUser === "company") {
      return "Company";
    } else if (data.typeOfUser === "team") {
      const _assignee = props.teamOptions.find((each) => each.value === data.assignee);
      if (_assignee) return `${_assignee.label} (Team)`;
    } else if (data.typeOfUser === "user") {
      const _assignee = props.userOptions.find((each) => each.value === data.assignee);
      if (_assignee) return `${_assignee.label} (User)`;
    }
    return "NA";
  };
  const getDuration = (data) => {
    if (data.duration) {
      if (data.duration.type === "automatic") {
        return "Automatic";
      } else if (data.duration.start && data.duration.end) {
        return `${moment(data.duration.start).format("L")} - ${moment(data.duration.end).format("L")}`;
      }
    }
    return "NA";
  };

  const getPipelineName = (data) => {
    if (props.pipelineOptions) {
      const _find = props.pipelineOptions.find((each) => each.value === data.pipelineId);
      if (_find) return _find.label;
      return `All Pipelines`;
    }
    return `All Pipelines`;
  };

  const getPipelineStageName = (data) => {
    if (props.pipelineStageOptions[data.pipelineId]) {
      const _find = props.pipelineStageOptions[data.pipelineId].find((each) => each.value === data.pipelineStageId);
      if (_find) return _find.label;
      return `All Stages`;
    }
    return `All Stages`;
  };
  const getSalesTarget = (data) => {
    return `${props.currency} ${data.salesTarget}`;
  };

  if (_.isEmpty(props.selectedSalesForecast)) return <></>;
  return (
    <Card className="sales-forecast-deatils-wrapper mb-3">
      <Card.Header>
        <span>Sales Forecast Details</span>
        <div>
          <EditIconButton onClick={() => props.onEditClick(props.selectedSalesForecast)} />
          <DeleteIconButton onClick={() => props.onDeleteClick(props.selectedSalesForecast)} />
        </div>
      </Card.Header>
      <Card.Body className="d-flex flex-row flex-wrap">
        <Col xs={6}>
          <div>
            <strong className="mr-2">Title:</strong> {props.selectedSalesForecast.title}
          </div>
          <div>
            <strong className="mr-2">Assignee:</strong> {getAssignee(props.selectedSalesForecast)}
          </div>
          <div>
            <strong className="mr-2">Forecast Type:</strong>
            {salesTargetAndForecastMapping[props.selectedSalesForecast.forecastType]}
          </div>
          <div>
            <strong className="mr-2">Pipeline:</strong>
            {getPipelineName(props.selectedSalesForecast)}
          </div>
          {props.selectedSalesForecast.pipelineStageId && (
            <div>
              <strong className="mr-2">Pipeline Stage:</strong>
              {getPipelineStageName(props.selectedSalesForecast)}
            </div>
          )}
        </Col>
        <Col xs={6}>
          {props.selectedSalesForecast.forecastType === "openAndWonDealsWithSalesTarget" && (
            <div>
              <strong className="mr-2">Sales Target:</strong>
              {getSalesTarget(props.selectedSalesForecast)}
            </div>
          )}
          {props.selectedSalesForecast.company && (
            <div>
              <strong className="mr-2">Company:</strong>
              {props.selectedSalesForecast.company.name}
            </div>
          )}
          <div>
            <strong className="mr-2">Interval:</strong>
            {salesTargetAndForecastMapping[props.selectedSalesForecast.interval]}
          </div>
          <div>
            <strong className="mr-2">Duration:</strong>
            {getDuration(props.selectedSalesForecast)}
          </div>
        </Col>
      </Card.Body>
    </Card>
  );
}
